// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect,  useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient'; 
import authServices from '../../../services/AuthServices';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const [selectedDates, setSelectedDates] = useState('');
  const dispatch = useDispatch();
  
  const loader = (display) => { 
    dispatch(CustomLoader(display)); 
  };

  const [formData, setFormData] = useState({
    
    id: '', 
    feeType: '',
  });

    // Handle input changes
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };  
      
  //*********************************** Fetch invoice data when the modal opens ********************************************************
  const token = authServices.getToken();
  useEffect(() => {
    
    const fetchInvoiceData = async () => {
      if (edit && invoiceId) {
        loader('enable');
        
        try {
          // API se response ko variable me store karna
          const response = await apiClient.get(`/api/admin/fee_type/${invoiceId}`, {
          
                  headers: {
                    'access_token': token,
                  },
          
                });
          
          if(response.data.Status === "SUCCESS") {
        
          setFormData({
            id: invoiceId || '',
            feeType: response.data.data.feeType || '',
          });
          }
            else{
              console.log(response.data.message)
            }
        } catch (error) {
          console.error('catch Error :- ', error.response ? error.response.data.message : error);
        } finally {
          loader('disable');
        }
      }
    };
  
    fetchInvoiceData();
  }, [invoiceId, edit]);  


  //******************************************* Handle save and update the data **************************************************
  const handleSave = async () => {
    loader('enable');
  
    try {
      const response = await apiClient.put(`/api/admin/fee_type/update`, formData, {
      
              headers: {
                'access_token': token,
              },      
            });
      if(response.data.Status === "SUCCESS") {
        
      }
        else{
          console.log(response.data.message)
        }  
      }
      catch (error) {
        console.error('catch Error :- ', error.response ? error.response.data.message : error);
      }
      finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };
  
  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Fee_Type
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>
                  <div className="spacing">
                    <label htmlFor="feeType" className="label-custom">Fee Type</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="feeType"
                      name="feeType"
                      value={formData.feeType}
                      onChange={handleChange}
                    />
                  </div>
                  
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
